import HomeIcon from "@mui/icons-material/Home";
import { Box, Button, Typography } from "@mui/material";
import { hexToRGBA } from "@utils/hex-to-rgba";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 4,
        textAlign: "center",
      }}
    >
      <Box>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          className="lucide lucide-space"
          style={{
            width: 96,
            height: 96,
            opacity: 0.8,
          }}
        >
          <path d="M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1" />
        </svg>
        <Typography
          variant="h1"
          sx={{ fontWeight: "bold", color: "white", mb: 2 }}
        >
          404
        </Typography>
        <Typography variant="h6" sx={{ color: "text.primary", mb: 4 }}>
          we've lost this page
        </Typography>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <Button
            component={Link}
            to="/"
            startIcon={<HomeIcon />}
            variant="outlined"
            color="primary"
            sx={{
              "&:hover": {
                backgroundColor: (theme) =>
                  hexToRGBA(theme.palette.primary.main, 0.2),
              },
            }}
          >
            Return Home
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
